import { useState } from "react";
import { Navbar, Container } from "react-bootstrap";
import { NavLink, Link } from "react-router-dom";
import { CATEGORIES } from "../../data/site";
import logo from '../../assets/Finance Logo.png'

function NavBar() {
  // Everything except Blog lives inside the Home hover menu.
  const menuItems = CATEGORIES.filter((c) => c.key !== "blog");
  const [open, setOpen] = useState(false);

  return (
    <Navbar expand="lg" sticky="top" className="fi-navbar py-2" collapseOnSelect>
      <Container>
        <Navbar.Brand as={Link} to="/" className="fi-brand">
         <img src={logo} alt="Finance Info"  style={{ height: "50px" }}/>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-nav" />
        <Navbar.Collapse id="main-nav">
          <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-4">
            {/* Home with hover dropdown */}
            <li
              className="nav-item dropdown fi-hover-dropdown"
              onMouseEnter={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}
            >
              <NavLink to="/" end className="nav-link d-inline-flex align-items-center gap-2">
                Home
                <svg className={`fi-caret ${open ? "open" : ""}`} width="11" height="11" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </NavLink>
              <ul className={`dropdown-menu fi-dropdown ${open ? "show" : ""}`}>
                {menuItems.map((c) => (
                  <li key={c.key}>
                    <Link
                      className="dropdown-item"
                      to={`/category/${c.key}`}
                      onClick={() => setOpen(false)}
                    >
                     {c.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
 <li className="nav-item">
              <NavLink to="/calculators" className="nav-link">
                Calculators
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/about" className="nav-link">
                About Us
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/category/blog" className="nav-link">
                Blog
              </NavLink>
            </li>
           
            <li className="nav-item">
              <NavLink to="/contact" className="nav-link">
                Contact Us
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/privacy-policy" className="nav-link">
                Privacy Policy
              </NavLink>
            </li>
          </ul>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
